import {
  useInfiniteScroll,
  useLazyGetSessionScreenshotsQuery,
} from '@carboncopyco/data';
import { Button, LoadingDots, Modal, TextBase } from '@carboncopyco/ui';
import { AspectRatio } from '@radix-ui/react-aspect-ratio';
import { useEffect } from 'react';
import { InfiniteList } from '../../../../InfiniteList';
import { Screenshot } from '../../../../Screenshot';

type ViewedScreensModalProps = {
  open: boolean;
  onClose: () => void;
  sessionId: string;
  workspaceId: string;
  organizationId: string;
};

export const ViewedScreensModal = ({
  open,
  onClose,
  sessionId,
  workspaceId,
  organizationId,
}: ViewedScreensModalProps) => {
  const {
    items: screens,
    isLoading,
    error,
    fetchFirstBatch,
    fetchNextBatch,
    isLoadingBatch,
  } = useInfiniteScroll(useLazyGetSessionScreenshotsQuery);

  useEffect(() => {
    fetchFirstBatch({
      sessionId,
      workspaceIds: workspaceId,
      organizationId,
    });
  }, [organizationId, sessionId, workspaceId]);

  return (
    <Modal
      title="Viewed sceenshots"
      open={open}
      onClose={onClose}
      containerClass="flex flex-col max-w-[1000px] min-w-[700px]"
    >
      <TextBase
        label="These are the demo sceenshots that were viewed during this session."
        color="text-ds-natural-600"
      />
      <div className="flex flex-col overflow-hidden max-h-[400px] mt-4">
        <InfiniteList
          loader={
            <div className="flex justify-center items-center h-44">
              <LoadingDots />
            </div>
          }
          isLoading={isLoading}
          isLoadingBatch={isLoadingBatch}
          error={error && { message: 'Error fetching screens' }}
          errorComponent={
            <div className="flex flex-col items-center justify-center gap-2 h-44">
              <TextBase
                label="Oops!"
                color="text-ds-natural-600"
              />
              <TextBase
                label="There was an error loading screens"
                color="text-ds-natural-400"
              />
            </div>
          }
          onReachBottom={() => {
            fetchNextBatch({
              sessionId,
              workspaceIds: workspaceId,
              organizationId,
            });
          }}
        >
          <div className="flex flex-wrap gap-x-4 gap-y-8 pb-10 pr-4">
            {screens?.map(({ image }) => {
              return (
                <div
                  key={`image-${image}`}
                  className="grow max-w-[180px] min-w-[150px]"
                >
                  <AspectRatio ratio={16 / 10}>
                    <Screenshot image={image ?? undefined} />
                  </AspectRatio>
                </div>
              );
            })}
          </div>
        </InfiniteList>
      </div>
      <div className="flex justify-end pt-5">
        <Button
          label="Close"
          onClick={onClose}
        />
      </div>
    </Modal>
  );
};
